/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/minimize_medium'
export default icon
